import { useFormContext } from '@oscar/form';
import { Button, Col, Row } from '@oscar/theme';
import { TextField } from 'common/components';
import React, { useEffect, useState } from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
import ResultChecklist from '../../ResultChecklist/index';
import { getStage } from '../utils';
import './styles.scss';

interface Props {
  statusRequest?: StatusInstance;
}

const ListCheckList = ({ statusRequest }: Props) => {
  const [formContext] = useFormContext();
  const [showList, setShowlist] = useState(false);
  const [dataCheckList, setDataCheckList] = useState({});
  const [label, setLabel] = useState('');
  const [showListCheckList, setShowListCheckList] = useState();
  const submitQAQCsTime =
    formContext.selectors?.getInitalValue()?.submitQAQCsTime;
  useEffect(() => {
    setShowListCheckList(
      formContext.selectors?.getInitalValue()?.submitQAQCsTime,
    );
  }, [submitQAQCsTime]);
  const handleClose = () => {
    setShowlist(false);
  };
  const handleClickButton = (data: any, textLabel: any) => {
    setShowlist(true);
    setLabel(textLabel);
    setDataCheckList(data);
  };

  const options =
    formContext.form
      ?.getFieldValue('listQAQCDetail')
      ?.slice(0, submitQAQCsTime?.submittedTime) || [];
  return showListCheckList ? (
    <>
      {options.map?.((item: any, index: any) => {
        const textLabel = `${getStage(index)} Inspection Result`;
        return (
          <div className="container" key={`${index}${textLabel}`}>
            <span className="text-label-submit-time">{textLabel}</span>
            <Button
              className="checklist-button"
              onClick={() => handleClickButton(item, textLabel)}
            >
              OPEN CHECKLIST
            </Button>
          </div>
        );
      })}
      {showList && (
        <ResultChecklist
          visible={showList}
          onClose={handleClose}
          data={dataCheckList}
          label={label}
        />
      )}
    </>
  ) : null;
};

export default ListCheckList;
